import Typography from '@/components/UI/typography/Typography';
import styles from './CircularProgress.module.scss';
import Box from '@/components/UI/box/Box';
const CircularProgress = ({
  stepNumber,
  progress
}) => {
  const radius = 10;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - progress / 100 * circumference;
  return <Box className={styles['circular-progress-container']} data-sentry-element="Box" data-sentry-component="CircularProgress" data-sentry-source-file="CircularProgress.tsx">
      <svg className={styles['circular-progress']} width="24" height="24" data-sentry-element="svg" data-sentry-source-file="CircularProgress.tsx">
        <circle className={styles['circle-background']} cx="12" cy="12" r={radius} strokeWidth="2.5" data-sentry-element="circle" data-sentry-source-file="CircularProgress.tsx" />
        <circle className={styles['circle-progress']} cx="12" cy="12" r={radius} strokeWidth="2.5" strokeDasharray={circumference} strokeDashoffset={offset} transform={`rotate(-90 12 12)`} data-sentry-element="circle" data-sentry-source-file="CircularProgress.tsx" />
      </svg>
      <Typography variant="bodyS_Bold" className={styles['step-number']} data-sentry-element="Typography" data-sentry-source-file="CircularProgress.tsx">
        {stepNumber}
      </Typography>
    </Box>;
};
export default CircularProgress;